import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField  from "../../../../../../ui/TextField";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  });

const SkillEditDesc = ({onFormChange, desc}) => {
  const classes = useStyles();
  const [descr, setDescr] = React.useState(desc);

  const onChange = (value) => {
    setDescr(value);
    onFormChange({"description": value});
  };

  return (
      <div className={classes.root}>
        <Typography className={classes.heading}>Описание</Typography>
        <TextField
          multiline
          label=""
          value={desc}
          onChange={(e) =>  onChange(e.target.value)}
        />
      </div>
  );
};

export default SkillEditDesc;
